import  React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./BulkLoginMobile.module.css"
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Input,
  TextField,
   Autocomplete,
   Table,
   TableRow,
   TableHead,
   Collapse,
   IconButton,
   TableBody,
   TablePagination
} from "@mui/material";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { readFile } from "../utils/utils";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { useLocalStorage } from "@uidotdev/usehooks";
import Sidebar from "../sidenav/Sidenav";
import { ReactComponent as Hemberger } from '../assets/icons/Hemberger.svg';
import { ReactComponent as UserIcon } from '../assets/icons/UserIcon.svg';
import { Link, useNavigate } from "react-router-dom";
import { ArrowBackIosNewRounded } from "@mui/icons-material";
import { hasStoredTabAccess } from '../utils/access';

function formatDateAndTime(date) {
  date = new Date(date);
  let ISTDate = new Date(date.getTime());

  let day = ISTDate.getDate();
  let month = ISTDate.getMonth() + 1;
  let year = ISTDate.getFullYear();

  day = day < 10 ? '0' + day : day;
  month = month < 10 ? '0' + month : month;
  let formattedDate = `${day}.${month}.${year}`;

  let hours = ISTDate.getHours();
  let minutes = ISTDate.getMinutes();
  let AmOrPm = hours >= 12 ? 'PM' : 'AM';
  hours = (hours % 12) || 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  let formattedTime = `${hours}:${minutes} ${AmOrPm}`;

  return { time: formattedTime, date: formattedDate };
  
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow>
        <TableCell style={{maxWidth: '20ch', wordWrap:'break-word'}}>
          <div>{row?.userId}</div>
          
        </TableCell>
        {/* <TableCell align="right">
          <div>{formatDateAndTime(row?.created_at).date}</div>
          <div>{formatDateAndTime(row?.created_at).time}</div>
        </TableCell> */}
        <TableCell>
          <div>{row?.name}</div>
        <div>{row?.username}</div>
        </TableCell>
        {/* <TableCell>
          <div>{row?.email}</div>
        </TableCell> */}
        <TableCell>
          <IconButton
            aria-label="expand row"
            style={{ color: 'black' }}
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow sx={{ "& td": { border: 0, height: open ? 'auto' : 0 }, borderBottom: '1px solid black', }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderTop: 'none' }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit  >
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 150px', rowGap: '6px', fontSize: '10px', marginTop: '4px', marginBottom: '4px' }}>
                <div>Email: {row?.email}</div>
                <div>Mobile: {row?.mobile}</div>
                <div>Date: {row?.createdAt}</div>
                <div>DOB: {row?.dob}</div>
                <div>Referred By: {row?.referredBy}</div>
                <div>Subscription: {row?.subscriptions}</div>
              </div>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const BulkLoginMobile = () => {
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useLocalStorage('token', null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
    const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [updateFile, setUpdateFile] = useState(null);
  const [page, setPage] = useState(0);
  const [addDialog, setAddDialog] = useState(false);
  const navigate=useNavigate()
  const [institutes, setInstitutes] = useState([]);
  const [updateDialog, setUpdateDialog] = useState(false);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [tableData, setTableData] = useState([]);
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const displayedtable = tableData.slice(startIndex, endIndex);

  const isAuthorized = hasStoredTabAccess('Bulk Login');

  const handleAdd = async () => {
    try {
      const formData = new FormData();
      formData.append("excelFile", selectedFile);

      await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/bulkRegister/add`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Users added successfully");
    } catch (error) {
      console.error("Error adding Users:", error);
      if (error.response && error.response.status === 409) {
        toast.error(`${error.response.data.message}`);
      } else {
        toast.error(`Error adding Users: ${error.message}`);
      }
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setSelectedFileName(file.name);
  };
  const [updateFileName, setUpdateFileName] = useState("");
  const handleUpdateFileChange = (event) => {
    const file = event.target.files[0];
    setUpdateFile(file);
    setUpdateFileName(file.name);
  };

  const fromDateChangeHandler = (value) => {
    const date = value.target.value;
    setFromDate(date);
  };

  const toDateChangeHandler = (value) => {
    const date = value.target.value;
    setToDate(date);
  };

  const getInstituteData = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/institute/getAll`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const temp = response.data.data?.map((ele) => {
      return {
        label: `${ele.institute_name} (${ele.institute_referral_id})`,
        institute_id: ele.institute_id,
      };
    });
    setInstitutes(temp);
  };

  useEffect(() => {
    getInstituteData();
  }, []);

  const onDownloadPress = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/bulkRegister/getAll`,
        {
          responseType: "blob",
          params: {
            selectedInstitute: encodeURIComponent(
              JSON.stringify(selectedInstitute)
            ),
            fromDate: encodeURIComponent(JSON.stringify(fromDate)),
            toDate: encodeURIComponent(JSON.stringify(toDate)),
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "BulkUsers.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("File downloaded successfully");
    } catch (error) {
      const { data } = error.response;
      const file = await readFile(data);
      const { message } = JSON.parse(file);
      toast.error(message);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const handleUpdate = async () => {
    try {
      const formData = new FormData();
      formData.append("excelFile", updateFile);

      await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/bulkRegister/update`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Users added successfully");
    } catch (error) {
      console.error("Error adding Users:", error);
      if (error.response && error.response.status === 409) {
        toast.error(`${error.response.data.message}`);
      } else {
        toast.error(`Error adding Users: ${error.message}`);
      }
    }
  };
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  if (!isAuthorized) {
    return (
      <div className="container-fluid mt-5">
        <h2 style={{marginTop: '5%'}}>You are unauthorized to access this page</h2>
      </div>
    );
  }

  const onDisplayPress = async () => {
    if(!selectedInstitute || !fromDate || !toDate) {
      console.log("Show Toast");
      
      toast.error("Please select all fields")
      return;
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/bulkRegister/display`,
        {
          params: {
            selectedInstitute: encodeURIComponent(
              JSON.stringify(selectedInstitute)
            ),
            fromDate: encodeURIComponent(JSON.stringify(fromDate)),
            toDate: encodeURIComponent(JSON.stringify(toDate)),
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setTableData(response.data.data)
      console.log(response.data.data, " all data for display");
      toast.success("Data fetched successfully");
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message)
    }
  };

  return (
    <>
              <ToastContainer />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0.5rem 0.75rem 1.25rem 0.75rem' }}>
        <div onClick={() => setIsSidebarOpen(!isSidebarOpen)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', width: '36px', height: '36px', borderRadius: '18px', background: '#EAF1F7' }}>
          <Hemberger />
        </div>
        <Link to="/profile">
          <UserIcon />
        </Link>
      </div>
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', margin: '1.313rem 0.75rem' }}>
      <div
              style={{
                display: "flex",
                gap: "1vw",
                alignItems: "center",
                // marginBottom:"2.25rem"
              }}
            >
              <ArrowBackIosNewRounded
                onClick={() => {
                  navigate("/dashboard");
                }}
                style={{ cursor: "pointer" }}
              />
              <h4 style={{ marginRight: "1rem", marginBottom: "0px" }}>
                Bulk Login
              </h4>
            </div>
        <div>
          <Button
            variant="contained"
            onClick={() => {
              setUpdateDialog(true);
            }}
            className="button-two mr-1"
            style={{ width: '6rem', background: '#37446F', height: '1.75rem' }}
          >
            Update
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setAddDialog(true);
            }}
            className="button-two"
            style={{ width: '6rem', background: '#37446F', height: '1.75rem' }}
          >
            Add
          </Button>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: '2.179vw 0.75rem' }}>
        <Autocomplete
          fullWidth
          value={selectedInstitute}
          onChange={(event, newValue) => {
            setSelectedInstitute(newValue);
          }}
          options={institutes}
          isOptionEqualToValue={(option, value) =>
            option.id === value.id || value === null
          }
          renderInput={(params) => (
            <TextField {...params} label="Institute Name"
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'transparent',
                },
                '&:hover fieldset': {
                  borderColor: 'transparent',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'transparent',
                  boxShadow: 'none',
                },
              },
              marginBottom: '1rem'
            }}
            style={{
              boxShadow: '0px 1.74px 3.48px 0px #0000001A inset, 0px -1.74px 3.8px 0px #C8C7C740 inset, 0px 1.74px 3.48px 0px #0000001A'
            }}
            InputLabelProps={{
              sx: { "&.Mui-focused": { color: "#A8A8A8" } },
              required: false
            }}
            />
          )}
        />
        <div>
          <TextField
            label="From Date"
            type="date"
            // value={fromDate}
            onChange={fromDateChangeHandler}
            InputLabelProps={{
              shrink: true,
            }}
            margin="normal"
            style={{ marginRight: "0.75rem" }}
          />
          <TextField
            label="To Date"
            type="date"
            // value={toDate}
            onChange={toDateChangeHandler}
            InputLabelProps={{
              shrink: true,
            }}
            margin="normal"
            style={{   }}
          />
        </div>
        <div className="mt-3" style={{ display: 'flex', flexDirection:"column",gap:"0.5rem", margin: '3.25rem 0.75rem', width: '100%',marginBottom:"1rem" }}>
          <Button
            variant="contained"
            fullWidth
            onClick={onDownloadPress}
            className="button-two"
            style={{ alignSelf: "center", background: '#37446F', height: '2.25rem', marginTop: '12px' }}
          >
            Download
          </Button>
          <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={onDisplayPress}
                style={{ alignSelf: "center", background: '#37446F', height: '2.25rem', marginTop: '12px' }}
                className="button-two"
              >
                Display
              </Button>
        </div>
        {
              tableData.length > 0 && (
                <>
                <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            component="div"
            count={tableData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              '& .MuiTablePagination-input': {
                marginRight: '0.5rem',
                marginLeft: '0',
              }
            }}
          />
                
                <Table aria-label="collapsible table" 
                sx={{
                  [`& .${tableCellClasses.root}`]: {
                    borderBottom: "none"
                  }
                }}
                >
             <TableHead style={{ height: '2.564vw', borderRadius: '4px !important', background: 'rgba(234, 241, 247, 1)', boxShadow: '2px 2px 4px 0px rgba(174, 174, 192, 0.5)' }}>
                <TableRow>
                  <TableCell className={styles.tableCell}>S. No.</TableCell>
                  <TableCell className={styles.tableCell} style={{ textAlign: 'left' }}>Name & Username</TableCell>
                  {/* <TableCell className={styles.tableCell}>Email</TableCell> */}
                  <TableCell className={styles.tableCell} style={{ textAlign: 'left' }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  displayedtable?.map((data, index) => {
                    console.log(data);
                    
                    return (
                      <Row key={index} row={data} />
                      // <tr key={index}>
                      //   <td className={styles.tableCell} >{data.userId}</td>
                      //   <td className={styles.tableCell} style={{ textAlign: 'left' }}>
                      //     <>
                      //       <p style={{ padding: '0', margin: '0' }}>{data.name}</p>
                      //       <p style={{ padding: '0', margin: '0' }}>{data.username}</p>
                      //     </>
                      //   </td>
                      //   <td className={styles.tableCell} >
                      //       <p style={{ padding: '0', margin: '0' }}>{formatDateAndTime(data.createdAt).date}</p>
                      //       <p style={{ padding: '0', margin: '0' }}>{formatDateAndTime(data.createdAt).time}</p>
                      //   </td>
                      //   <td className={styles.tableCell} style={{ textAlign: 'left' }}>{data.email}</td>
                      //   <td className={styles.tableCell} >{data.mobile}</td>
                      //   <td className={styles.tableCell} >{data.dob}</td>
                      //   <td className={styles.tableCell} >{data.referredBy}</td>
                      //   <td className={styles.tableCell} >{data.subscriptions}</td>
                      // </tr>
                    )
                  })
                }
              </TableBody>
              </Table>
              </>
              )
            }
      </div>

      {/* Update Dialog */}
      <Dialog
        open={updateDialog}
        fullWidth
        onClose={() => {
          setUpdateDialog(false);
        }}
        className="d-flex flex-column justify-content-center"

      >
        <DialogTitle>Update User</DialogTitle>
        <DialogContent>
          <label htmlFor="file-upload" className={styles.customFileUpload} >
            Choose File
          </label>
          <Input
            id="file-upload"
            style={{ display: 'none' }}
            type="file"
            fullWidth
            onChange={handleUpdateFileChange}
          />
          <p style={{ margin: '0', padding: '0', textAlign: 'center' }}>{updateFileName ? 'File Chosen' : 'No file chosen'}</p>
          <Button
            variant="contained"
            onClick={handleUpdate}
            fullWidth
            style={{ marginTop: "1vw", background: '#37446F', height: '2.25rem', textTransform: 'none' }}
          >
            Update Users
          </Button>
        </DialogContent>
      </Dialog>
      
      {/* Add Dialog Box */}
      <Dialog
        open={addDialog}
        fullWidth
        // maxWidth="md"
        onClose={() => {
          setAddDialog(false);
        }}
        className="d-flex flex-column justify-content-center"
      >
        <DialogTitle>Add User</DialogTitle>
        <DialogContent>
          <label htmlFor="file-upload" className={styles.customFileUpload} >
            Choose File
          </label>
          <Input
            id="file-upload"
            style={{ display: 'none' }}
            type="file"
            fullWidth
            onChange={handleFileChange}
          />
          <p style={{ margin: '0', padding: '0', textAlign: 'center' }}>{selectedFileName ? 'File Chosen' : 'No file chosen'}</p>
          <Button
            variant="contained"
            onClick={handleAdd}
            fullWidth
            style={{ marginTop: "1vw", background: '#37446F', height: '2.25rem', textTransform: 'none' }}
          >
            Add Users
          </Button>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default BulkLoginMobile